/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import React from 'react';
import Icon from '@ant-design/icons';
import { ReactSVG } from 'react-svg';
import * as Unicons from '@iconscout/react-unicons';

// Helper to parse icon path string like "icon/24px/unicon/sun"
const parseIconPath = (iconPath) => {
  if (typeof iconPath !== 'string') return null;
  const match = iconPath.match(/icon\/(\d+)px\/unicon\/(.+)/);
  if (!match) return null;
  return {
    size: parseInt(match[1], 10),
    iconName: match[2],
  };
};

// Helper to convert kebab-case to PascalCase with Uil prefix
const kebabToPascalCase = (kebabCase) =>
  `Uil${kebabCase
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')}`;

const IconCreate = ({
  svg,
  color,
  width = 16,
  height = 16,
  style = { marginBottom: 2, marginRight: 5 },
  injection = false,
}) => {
  // Check if svg is a unicon path string
  const iconPathData = parseIconPath(svg);

  if (iconPathData) {
    // Handle unicon path
    const componentName = kebabToPascalCase(iconPathData.iconName);
    let UniconComponent = Unicons[componentName];

    // Try without "-o" suffix (outlined naming in some configs)
    if (!UniconComponent && iconPathData.iconName.endsWith('-o')) {
      const baseName = iconPathData.iconName.slice(0, -2);
      const baseComponentName = kebabToPascalCase(baseName);
      UniconComponent = Unicons[baseComponentName];
    }

    if (UniconComponent) {
      return (
        <Icon
          component={() => <UniconComponent size={width} color={color || 'white'} style={style} />}
          style={{
            backgroundColor: 'transparent !important',
          }}
        />
      );
    }

    // Fallback to a safe default icon so it never renders blank
    if (Unicons.UilApps) {
      return (
        <Icon
          component={() => <Unicons.UilApps size={width} color={color || 'white'} style={style} />}
          style={{
            backgroundColor: 'transparent !important',
          }}
        />
      );
    }
  }

  // Handle regular SVG (existing behavior)
  const MyIcon = () => (
    <ReactSVG
      style={{
        width,
        height,
        backgroundColor: 'transparent',
        ...style,
      }}
      beforeInjection={(svg) => {
        !injection
          ? () => {
              svg.classList.add('svg-class-name');
              const el = [...svg.querySelectorAll('path')];
              const gEl = [...svg.querySelectorAll('line')];
              el.forEach((e) => {
                e.setAttribute('fill', color ?? 'white');
              });
              gEl.forEach((e) => {
                e.setAttribute('stroke', color ?? 'white');
              });
              svg.setAttribute('width', width);
              svg.setAttribute('height', height);
            }
          : injection(svg);
      }}
      src={svg}
    />
  );

  return (
    <Icon
      component={MyIcon}
      style={{
        backgroundColor: 'transparent !important',
      }}
    />
  );
};

export default IconCreate;
